import { makeObservable, observable, action } from 'mobx';
import { IRecordsOverviewRow } from '../../../swagger/gd/record';

class RequestsStore {
  data: IRecordsOverviewRow[] = [];
  isConsentOpen: boolean = false;
  consentRequestId?: string = undefined;

  constructor() {
    makeObservable(this, {
      data: observable,
      isConsentOpen: observable,
      consentRequestId: observable,
      setData: action,
      openConsent: action,
      closeConsent: action
    });
  }

  setData = (rows: IRecordsOverviewRow[]) => {
    this.data = rows;
  };

  openConsent = (id: string) => {
    this.consentRequestId = id;
    this.isConsentOpen = true;
  };

  closeConsent = () => {
    this.isConsentOpen = false;
    this.consentRequestId = undefined;
  };
}

const requestsStore = new RequestsStore();
export default requestsStore;
